import React from "react";
import { Button, Box, Grid } from "@mui/material";
import "./styles.css";

const TabSelectButtonGroup = ({ options = [], selected, onChange }) => {
  const optionsGrid = 12 / options.length;

  return (
    <Grid container spacing={1} justifyContent="center">
      {options.map((option) => (
        <Grid item xs={6} md={optionsGrid}>
          <Button
            key={option.value}
            onClick={() => onChange(option.value)}
            sx={{
              backgroundColor:
                selected === option.value ? "#E9E9FD" : "#7878FF",
              color: selected === option.value ? "#4444B2" : "#fff",
              fontSize:'14px',
              fontWeight: "bold",
              textTransform: "none",
              height: "42px",
              width: "100%",
              borderRadius: "8px",
              borderWidth: "2px",
              borderStyle: "solid",
              borderColor:
                selected === option.value ? "#A4A4FD" : "transparent",
              boxShadow:
                selected === option.value
                  ? "none"
                  : " 0px 4px 4px 0px rgba(0, 0, 0, 0.25);",
              "&:hover": {
                backgroundColor:
                  selected === option.value ? "#E9E9FD" : "#5A5AFF",
                borderColor: selected === option.value ? "#A4A4FD" : "#5A5AFF"
              }
            }}
          >
            {option.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default TabSelectButtonGroup;
